<template>
    <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="innerValue"
        persistent
        width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="innerValue"
                :label="label"
                outlined
                readonly
                :prepend-inner-icon="prepand_icon"
                v-on="on"
                :rules="rules"
            />
        </template>
        <v-date-picker v-model="innerValue" scrollable :max="maxDate">
            <v-spacer/>
            <v-btn color="red lighten-1" class="white--text" @click="modal = false">Cancel</v-btn>
            <v-btn color="primary" @click="$refs.dialog.save(innerValue)">OK</v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>

    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [];
                },
            },
            label: {
                type: String,
                value: ''
            },
            prepand_icon: {
                type: String,
                value: ''
            },
            value: {
                type: ''
            },
            maxDate: {
                type: String,
            }
        },
        name: "OutlinedDatePicker",
        data() {
            return {
                modal: false,
                innerValue: ''
            }
        },
        watch: {
            innerValue(new_value) {
                this.$emit('input', new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            }
        },
        created() {
            if (this.value) {
                this.innerValue = this.value;
            }
        }
    }
</script>
